exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".animated-input-label{position:relative}.animated-input-label label{position:absolute;top:50%;transform:translateY(-50%);padding:0 .33rem;font-size:1rem;left:.5rem}.animated-input-label.is-animated label{transition:all .25s ease}.animated-input-label.input-label-docked label{transform:translateY(-150%);font-size:.75rem}.animated-input-label.input-label-docked label:after{background:#fff;content:\"\";position:absolute;top:calc(.5rem - 1px);left:0;display:block;height:3px;width:100%;z-index:-1}.animated-input-label .iti~label{left:3rem}", ""]);

// exports
